import React from "react"
import { graphql } from "gatsby"
import Button from "../../button/Button"

const HeroBanner = props => {
  const { headline, subHeadline, button, video } = props

  return (
    <div className="relative h-full w-full bg-darkBlue">
      <div className="flex h-full w-full items-center justify-center">
        <div className="absolute z-50 mb-[15%] flex flex-col items-center justify-center px-[15px] md:px-5">
          {headline && (
            <>
              <h1
                id="commercial-header"
                className="hidden text-center leading-[47px] tracking-wide text-white drop-shadow-[4px] md:mb-[15px] md:block"
              >
                {headline}
              </h1>
              <h4
                id="commercial-header"
                className="block text-center leading-[47px] tracking-wide text-white drop-shadow-[4px] md:mb-[15px] md:hidden"
              >
                {headline}
              </h4>
            </>
          )}
          {subHeadline && (
            <p
              id="commercial-subTitle"
              className="mt-0.5 mb-2 max-w-[706px] text-center text-body2 text-white md:mb-[50px] md:text-subTitle1 "
            >
              {subHeadline}
            </p>
          )}

          {button && (
            <>
              <Button
                className=" block  sm:hidden"
                variant="primary"
                to={button.link}
                size="medium"
              >
                {button.title}
              </Button>
              <Button
                className=" hidden  sm:block"
                variant="primary"
                to={button.link}
                size="large"
              >
                {button.title}
              </Button>
            </>
          )}
        </div>
        <video
          controls={false}
          autoPlay
          muted
          loop={true}
          className="pointer-events-none relative z-10 w-full"
        >
          <source src={video?.publicUrl} type="video/mp4" />
        </video>
      </div>
    </div>
  )
}

export default HeroBanner

export const fragment = graphql`
  fragment HeroBanner on WpDefaultTemplate_Acf_Modules {
    ... on WpDefaultTemplate_Acf_Modules_HeroBanner {
      fieldGroupName
      headline
      subHeadline
      video {
        id
        mediaItemUrl
        publicUrl
      }
      button {
        target
        title
        url
      }
    }
  }
`
